import { SignStickerDetail } from '../sign/sticker/sign-sticker-detail';
import { Adjustment } from './adjustment';

export class SoldRented extends Adjustment {
  installByInpress?: boolean;
  useStandardLayout?: boolean;
  otherSticker?: string;
  signSticker?: SignStickerDetail;
  printStickerChecked?: boolean;

  constructor() {
    super();
    this.type = 'SoldRented';
    this.installByInpress = true;
  }
}
